import SrInputNumber from '@/components/SrInputNumber.vue'
import MultiSelect from 'primevue/multiselect'
import Select from 'primevue/select'
import { AVAILABLE_EXCHANGES } from '@/utils/consts'
import { i18n } from '@/i18n'
import { markRaw } from 'vue'
import { z } from 'zod'
import InputText from 'primevue/inputtext'
import isString from 'lodash/isString'

export function createSplashFilters() {
  const { t } = i18n.global
  const swapFilters = [
    {
      header: 'exchanges',
      field: 'exchanges',
      component: markRaw(MultiSelect),
      placeholder: 'Gate, Mexc, Ourbit, Lbank',
      zod: z.string().array().optional().nullable(),
      containerClass: 'lg:col-span-2',
      props: {
        filterMatchMode: 'startsWith',
        showClear: true,
        options: AVAILABLE_EXCHANGES,
        optionLabel: 'title',
        optionValue: 'value',
        filter: true,
        emptyFilterMessage: t('emptyMessage'),
      },
    },
    {
      field: 'symbols',
      header: 'symbols',
      component: markRaw(InputText),
      placeholder: 'BTC, BNB, SOL...',
      containerClass: 'lg:col-span-2',
      zod: z.string().optional().nullable(),
    },
    {
      field: 'excludeSelectedSymbols',
      header: 'symbolsFilterMode',
      component: markRaw(Select),
      containerClass: 'lg:col-span-2',
      zod: z.boolean().nullable().optional(),
      get props() {
        return {
          options: [
            {
              label: t('filters.excludeSelected'),
              value: true,
            },
            {
              label: t('filters.showSelected'),
              value: false,
            },
          ],
          optionLabel: 'label',
          optionValue: 'value',
          showToggleAll: false,
          emptyFilterMessage: t('emptyMessage'),
        }
      },
    },
    {
      field: 'total_2h',
      header: 'total2h',
      component: markRaw(SrInputNumber),
      containerClass: 'lg:col-span-2',
      placeholder: '10',
      zod: z.preprocess(
        (x: string | null) => (isString(x) && x.trim() === '' ? null : Number(x)),
        z.number().nullable(),
      ),
      props: {
        step: 0.5,
        showButtons: true,
        maxFractionDigits: 2,
      },
    },
    // {
    //   field: 'total_12h',
    //   header: 'total12h',
    //   component: markRaw(SrInputNumber),
    //   placeholder: '10',
    //   zod: z.preprocess(
    //     (x: string | null) => (isString(x) && x.trim() === '' ? null : Number(x)),
    //     z.number().nullable(),
    //   ),
    //   containerClass: 'lg:col-span-1',
    //   props: {
    //     step: 0.5,
    //     showButtons: true,
    //     maxFractionDigits: 2,
    //   },
    // },

    {
      field: 'grp',
      header: 'movementGrp',
      component: markRaw(Select),
      zod: z.number().nullable().optional(),
      containerClass: 'lg:col-span-2',
      get props() {
        return {
          options: [
            {
              label: '5%',
              value: 5,
            },
            {
              label: '10%',
              value: 10,
            },
            {
              label: '15%',
              value: 15,
            },
            {
              label: '20%',
              value: 20,
            },
          ],
          optionLabel: 'label',
          optionValue: 'value',
          showToggleAll: false,
          emptyFilterMessage: t('emptyMessage'),
        }
      },
    },
    {
      field: 'total_24h',
      header: 'total24h',
      component: markRaw(SrInputNumber),
      placeholder: '10',
      zod: z.preprocess(
        (x: string | null) => (isString(x) && x.trim() === '' ? null : Number(x)),
        z.number().nullable(),
      ),
      containerClass: 'lg:col-span-2',
      props: {
        step: 0.5,
        showButtons: true,
        maxFractionDigits: 2,
      },
    },
  ]
  return swapFilters
}
